import * as React from "react";

import pageStyles from "./styles";
import Model from "hooks/Model";

const BetaBubble = () => {
  const styles = pageStyles();

  const showBetaInfo = () => {
    Model.setData("dialog", {
      open: true,
      title: "👩‍💻 Versión BETA 👨‍💻",
      text: "Nuestro equipo está trabajando constantemente para potenciar los servicios de la plataforma de FROIN.\n\nAl ser una versión BETA, puede que encuentres oportunidades de mejora. Te agradeceríamos si te animas comunicarlas por medio de [[WhatsApp]] o al correo hello@froin.co",
      link: "https://api.whatsapp.com/send?app_absent=0&phone=573012069045&text=Solicito%20hablar%20con%20un%20asesor&type=phone_number",
      txtRight: "Entendido",
      fnRight: () => {
        Model.setData("dialog", {
          open: false,
        });
      },
    });
  };

  return (
    <button onClick={showBetaInfo} className={styles.container}>
      BETA
    </button>
  );
};

export default BetaBubble;
